document.addEventListener('DOMContentLoaded', function () {
    const coursesBtn = document.getElementById('coursesBtn');
    const coursePopup = document.getElementById('coursePopup');

    if (coursesBtn && coursePopup) {
        // Toggle popup on button click
        coursesBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            coursePopup.classList.toggle('open');
            this.classList.toggle('open');
        });

        // Hide popup when clicking outside
        document.addEventListener('click', function (e) {
            if (!coursePopup.contains(e.target) && !coursesBtn.contains(e.target)) {
                coursePopup.classList.remove('open');
                coursesBtn.classList.remove('open');
            }
        });

        // Prevention for clicks inside popup
        coursePopup.addEventListener('click', function (e) {
            e.stopPropagation();
        });

        // Sidebar category interactivity
        const categories = coursePopup.querySelectorAll('.course-popup__category');
        const contentTitle = coursePopup.querySelector('.course-popup__content-title');

        if (categories.length > 0) {
            categories.forEach(category => {
                category.addEventListener('click', function () {
                    // Update active category
                    categories.forEach(c => c.classList.remove('active'));
                    this.classList.add('active');

                    // Update content header title
                    if (contentTitle) {
                        const categoryName = this.querySelector('span').textContent;
                        contentTitle.textContent = categoryName;
                    }

                    // Toggle visibility of category-specific content
                    const targetId = 'content-' + this.dataset.category;
                    const contentAreas = coursePopup.querySelectorAll('.course-category-content');
                    contentAreas.forEach(area => {
                        if (area.id === targetId) {
                            area.style.display = 'block';
                            area.classList.add('active');
                        } else {
                            area.style.display = 'none';
                            area.classList.remove('active');
                        }
                    });

                    // Log category change
                    console.log('Category changed to:', this.dataset.category);
                });
            });
        }
    }
});
